import {
  OnboardingPayloadSchema,
  RegisterResponseSchema,
  type OnboardingPayload,
  type RegisterResponse,
} from '../contracts/onboarding';
import type { RequestFn } from './client';

/**
 * Namespace `client.onboarding` — обёртки над эндпоинтами Block 0 Phase 2
 * (PRD §2.2 + ADR-0012).
 *
 * Реализует только `POST /api/onboarding/register`. Stage 1 (Guest profile —
 * lang+city) живёт исключительно в Zustand+localStorage и НЕ отправляется на
 * сервер в Phase 2 (см. ADR-0012 §«Решение» 4 + 7).
 *
 * P-009 защита уровня 2 (ADR-0009) — `safeParse` через `.strict()` Zod-схему
 * до отправки запроса. Если type-checker обойдён (например, `as any`-cast в
 * тесте или регрессия в Container), `.strict()` блокирует extra-поля
 * (`region`, `password`, `passport_number`, etc.) — rejected Promise без
 * фактического сетевого вызова. Симметрия с `decors.match` / `paint.match`.
 *
 * Response парсится через `RegisterResponseSchema` (identity-only:
 * `jwt`, `userId`, `region`). Subscription state — отдельный `/api/me`
 * resource в Phase 4 (ADR-0012 amendment 07.05.2026, MEDIUM ISSUE 2 Path B).
 */
export interface OnboardingApi {
  register(payload: OnboardingPayload): Promise<RegisterResponse>;
}

export function createOnboardingApi(request: RequestFn): OnboardingApi {
  return {
    register: (payload) => {
      const parsed = OnboardingPayloadSchema.safeParse(payload);
      if (!parsed.success) {
        return Promise.reject(parsed.error);
      }
      return request({
        method: 'POST',
        path: '/api/onboarding/register',
        body: parsed.data,
        responseSchema: RegisterResponseSchema,
      });
    },
  };
}
